export const environment = {
  production: true,
  apiUrl: "http://amiss4.ifc.com.vn:1005/ServiceAmiss4/",
  localUserName: "UserInfo",
  sessionDanhMucName: "selectedDirectory",
  ipAddress: "ipAddress",
  timKiemKey: "timKiemValue",
  searchedKey: "searchedKey",
  version: '2.0.2',
  google_analytics_code: 'UA-136260204-1',
  API_URL: "http://192.168.1.233:45001/",
  LOCAL_USER_NAME: "UserInfo",
  SESSION_DANHMUC_NAME: "selectedDirectory",
  IP_ADDRESS: "ipAddress",
  TIM_KIEM_KEY: "timKiemValue",
  CHUYEN_TRANG_NAME: "isThongKeDangNhap",
  ACCOUNT_ID: "AccountID",
  ACCOUNT_NAME: "AccountName",
  FROMDATE: "FromDate",
  TODATE: "ToDate",
  LANGUAGE: "LANGUAGE",
  DsKhachHang: 'DsKhachHang',
  TimeOut: 'TimeOut',
};



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/environments/environment.prod.ts